import { render, staticRenderFns } from "./IntermediaryHelpList.vue?vue&type=template&id=cc5c3664&"
import script from "./IntermediaryHelpList.vue?vue&type=script&lang=js&"
export * from "./IntermediaryHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports